import { render } from "./ExpositionTemplateSetup.vue?vue&type=template&id=1f36b7b2&scoped=true"
import script from "./ExpositionTemplateSetup.vue?vue&type=script&lang=js"
export * from "./ExpositionTemplateSetup.vue?vue&type=script&lang=js"

import "./ExpositionTemplateSetup.vue?vue&type=style&index=0&id=1f36b7b2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/logexpo/logexpo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f36b7b2"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QIcon,QBtn});
